import { render, staticRenderFns } from "./PureLayout.vue?vue&type=template&id=1fa00cbc"
import script from "./PureLayout.vue?vue&type=script&lang=js"
export * from "./PureLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports